// src/redux/chargeApi.js
import { apiSlice } from "./apiSlice";

export const adminChargeApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // GET /api/user/charge/v1 - 청구 리스트 조회
        getChargeListAdmin: build.query({
            query: (params) => ({
                url: "/api/admin/charge/v1",
                method: "GET",
                headers: { token: true },
                params: params,
            }),
        }),
        // POST /api/user/charge/v1 - 청구하기
        postChargeAdmin: build.mutation({
            query: (body) => ({
                url: "/api/admin/charge/v1",
                method: "POST",
                headers: { token: true },
                data: body,
            }),
        }),
        // POST /api/user/charge/v1/pre_charge - 선 청구하기
        postPreChargeAdmin: build.mutation({
            query: (body) => ({
                url: "/api/admin/charge/v1/pre_charge",
                method: "POST",
                headers: { token: true },
                data: body,
            }),
        }),
        // GET /api/user/charge/v1/{chargeId} - 청구 상세조회
        getChargeDetailAdmin: build.mutation({
            query: (chargeId) => ({
                url: `/api/admin/charge/v1/${chargeId}`,
                method: "GET",
                headers: { token: true },
            }),
        }),
        // POST /api/admin/charge/v1/{chargeId}/fax/send - 팩스 전송
        postChargeFaxSend: build.mutation({
            query: ({ chargeId, body }) => ({
                url: `/api/admin/charge/v1/${chargeId}/fax/send`,
                method: "POST",
                headers: { token: true },
                data: body,
            }),
        }),
        // POST /api/admin/charge/v1/{chargeId}/fax/file - 팩스 파일 생성
        postChargeFaxFile: build.mutation({
            query: (chargeId) => ({
                url: `/api/admin/charge/v1/${chargeId}/fax/file`,
                method: "POST",
                headers: { token: true },
            }),
        }),

        // 청구 재계산
        putChargeCalculate: build.mutation({
            query: (chargeId) => ({
                url: `/api/admin/charge/v1/${chargeId}/calculate`,
                method: "PUT",
                headers: { token: true },
            }),
        }),

        // 청구 수수료 차감
        putChargeCommission: build.mutation({
            query: (chargeId) => ({
                url: `/api/admin/charge/v1/${chargeId}/commission`,
                method: "PUT",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useGetChargeListAdminQuery,
    usePostChargeAdminMutation,
    usePostPreChargeAdminMutation,
    useGetChargeDetailAdminMutation,
    usePostChargeFaxSendMutation,
    usePostChargeFaxFileMutation,
    usePutChargeCalculateMutation,
    usePutChargeCommissionMutation,
} = adminChargeApi;
